module.exports = require("@angular-devkit/core/src/utils/literals");